import type { PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'

export function ContextMenuPortal({ children }: PropsWithChildren) {
  if (typeof document === 'undefined') {
    return null
  }

  return createPortal(children, document.body)
}
